import React from "react";
import "../../styles/components/common/keyValueTextElementComponent.css";

export const KeyValueTextElement = ({ keyLabel, valueText, valueIcon, className = "", showBorder = false }) => {
  return (
    <div className={`keyValueContainer ${className} ${showBorder ? "border" : ""}`}>
      <span className="keyLabel">{keyLabel}</span>
      <span className="valueText">
        {valueText} {valueIcon}
      </span>
    </div>
  );
};

export default KeyValueTextElement;
